import { render, staticRenderFns } from "./AcountCompany.vue?vue&type=template&id=2695486a&scoped=true&"
import script from "./AcountCompany.vue?vue&type=script&lang=js&"
export * from "./AcountCompany.vue?vue&type=script&lang=js&"
import style0 from "./AcountCompany.vue?vue&type=style&index=0&lang=css&"
import style1 from "./AcountCompany.vue?vue&type=style&index=1&id=2695486a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2695486a",
  null
  
)

export default component.exports